export default __webpack_public_path__ + "static/featured-blog-4-e122dbacbee026d22fcd01f9cfc1bcd7.png";